import React from "react";
import * as Sentry from "@sentry/react";

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		Sentry.withScope((scope) => {
			scope.setExtras({ componentStack: errorInfo?.componentStack });
			Sentry.captureException(error);
		});
	}

	render() {
		if (this.state.hasError) {
			return (
				<div style={{ padding: 40, textAlign: "center" }}>
					<h2>Something went wrong.</h2>
					<p>The error has been reported. Please refresh the page.</p>
					<button onClick={() => window.location.reload()}>
						Refresh
					</button>
				</div>
			);
		}
		return this.props.children;
	}
}

export default ErrorBoundary;
